import React from 'react';
import reqwest from 'reqwest';
import swal from 'sweetalert';

import settings from '../../../../../settings';

import RightSide from '../../../../components/FormArea/RightSide';
import Loader from '../../../../components/Loader';
import Button from '../../../../components/Button';
import ContentBox from '../../../../components/FormArea/ContentBox';
import Input from '../../../../components/Inputs/Input';
import { faTimes, faSave } from '@fortawesome/pro-solid-svg-icons';
import DataContainer from '../../../../logic/dataContainer';

class EMailClientNew extends React.Component {
  constructor(props) {
    super(props);

    this.parentRoute = this.props.match.url.replace(/\/new$/, '');

    this.state = {
      loading: false,
    };

    this.dataContainer = new DataContainer();
    this.dataContainer.add('PermissionEntry', {
      Name: '',
      Bemerkung: '',
    });
  }

  save = () => {
    const Role = this.dataContainer.getStringified();

    reqwest({
      method: 'POST',
      url: settings.permissions.AddRole,
      data: {
        Token: localStorage.getItem('token'),
        Role,
      },
    }).then(saveResult => {
      saveResult = JSON.parse(saveResult);

      if (saveResult[0].Params.SaveResult === 'Saved') {
        swal({
          title: 'Erfolg!',
          text: 'Die Rolle wurde erfolgreich angelegt.',
          icon: 'success',
        });
        this.props.history.replace(this.props.match.url.replace(/\/new$/, `/${saveResult[0].Params.Guid}`));
      }
    });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <>
        <div className='FormArea-Form-Left'>
          <ContentBox title='Rolle'>
            <Input
              type='text'
              label='Name:'
              validator={[]}
              onChange={value => {
                this.dataContainer.set('PermissionEntry', 'Name')(value);
              }}
              defaultValue={this.dataContainer.get('PermissionEntry', 'Name')}
              name='Name'
            />
            <Input
              type='text'
              label='Bemerkung:'
              validator={[]}
              onChange={value => {
                this.dataContainer.set('PermissionEntry', 'Bemerkung')(value);
              }}
              defaultValue={this.dataContainer.get('PermissionEntry', 'Bemerkung')}
              name='Bemerkung'
            />
          </ContentBox>
        </div>
        <RightSide>
          <Button big icon={faTimes} to={this.parentRoute}>
            Abbrechen
          </Button>
          <Button big type='primary' icon={faSave} onClick={this.save}>
            Speichern
          </Button>
        </RightSide>
      </>
    );
  }
}

export default EMailClientNew;
